import React, { useCallback, useMemo, useRef, useState } from 'react';
import { ISurvey } from 'src/redux/features/surveys/allSurvey/types';
import styles from './styles.styl';
import cn from 'classnames/bind';
import { Text } from '@consta/uikit/Text';
import { formatDate } from 'src/utils';
import { Button } from '@consta/uikit/Button';
import { IconKebab } from '@consta/uikit/IconKebab';
import { Badge } from '@consta/uikit/Badge';
import { ContextMenu } from '@consta/uikit/ContextMenu';
import { IUserInitEnums } from 'src/redux/features/userInit/types';
import { LocalStorageKeysEnum, SurveyStatusEnum } from 'src/utils/enum';
import { connect } from 'react-redux';
import { loadDeleteSurvey } from 'src/redux/features/surveys/deleteSurvey/actions';
import {
  changeStatusSurveyIdle,
  loadChangeSurveyStatus,
} from 'src/redux/features/surveys/changeSurveyStatus/actions';
import { loadDuplicateSurvey } from 'src/redux/features/surveys/duplicateSurvey/actions';
import {
  duplicateSurveyPendingSelector,
  duplicateSurveyRejectedSelector,
} from 'src/redux/features/surveys/duplicateSurvey/selectors';
import { State } from 'src/redux/reducer';
import {
  deleteSurveyLoadedSelector,
  deleteSurveyPendingSelector,
  deleteSurveyRejectedSelector,
} from 'src/redux/features/surveys/deleteSurvey/selectors';
import { changeStatusSurveyLoadedSelector } from 'src/redux/features/surveys/changeSurveyStatus/selectors';
import { IconClose } from '@consta/uikit/IconClose';
import { Modal } from '@consta/uikit/Modal';
import { CloseModal } from '../CloseModal';
import { ErrorPublishModal } from 'src/components/ErrorPublishModal';
import QRCodeLinkModal from 'src/components/QRCodeLinkModal';
import { useHistory } from 'react-router-dom';
import { oneSurveyIdle } from 'src/redux/features/surveys/oneSurvey/actions';
import { TitleCreateTestType } from 'src/redux/features/surveys/titleCreateTest/types';
import { setTitleNew } from 'src/redux/features/surveys/titleCreateTest/actions';
import {
  CreateTestEditTitle,
  ErrorPredPreviewText,
  ErrorPredPreviewTitle,
  ErrorPublishText,
  ErrorPublishTitle,
  SurveyItemDateEnded,
  SurveyItemDatePublished,
  SurveyItemShareTooltipText,
} from 'src/config/config';
import { clearAllListQuestions } from 'src/redux/features/questions/allListQuestions/actions';
import { unloadSurvey } from 'src/redux/features/surveys/unloadSurvey/actions';
import { withTooltip } from '@consta/uikit/withTooltip';

const cx = cn.bind(styles);

export interface ISurveyItemProps {
  survey: ISurvey;
  userInit: IUserInitEnums;
  deleteSurvey?: (id: number) => void;
  changeStatus?: (id: number, status: number) => void;
  duplicateSurvey?: (id: number | string) => void;
  setDeletedName: (name: string) => void;
  changeStatusSurveyIdle?: () => void;
  oneSurveyIdle?: () => void;
  setTitleNew?: (data: TitleCreateTestType) => void;
  clearAllListQuestions?: () => void;
  unloadSurvey?: (id: number) => void;
}

const SurveyItem: React.FC<ISurveyItemProps> = ({
  survey,
  userInit,
  deleteSurvey,
  duplicateSurvey,
  changeStatus,
  setDeletedName,
  changeStatusSurveyIdle,
  oneSurveyIdle,
  setTitleNew,
  clearAllListQuestions,
  unloadSurvey,
}) => {
  const ref = useRef();
  const history = useHistory();
  const [isOpen, setIsOpen] = useState<boolean>(false);
  const [deleteModalOpen, setDeleteModalOpen] = useState(false);
  const [errorModalOpen, setErrorModalOpen] = useState(false);
  const [qrCodeModalOpen, setQrCodeModalOpen] = useState(false);
  const [dataModalPublish, setDataModalPublish] = useState({
    title: '',
    text: '',
  });

  const openAnalytics = () => history.push(`/analytics/${survey.id}`);

  const isValidToPublish =
    survey.name &&
    survey?.cnt_questions > 0 &&
    survey.welcome_page_header &&
    survey.welcome_page_description &&
    survey.final_page_header &&
    survey.final_page_description;

  const isValidToView =
    survey.name &&
    survey?.cnt_questions > 0 &&
    ((survey.welcome_page_header &&
      survey.welcome_page_description &&
      survey.final_page_header &&
      survey.final_page_description) ||
      survey.status !== SurveyStatusEnum.DRAFT);

  const generalItems = [
    {
      name: 'Дублировать',
      action: () => duplicateSurvey(survey?.id),
    },
    {
      name: 'Удалить',
      action: () => {
        setDeletedName(survey?.name);
        setDeleteModalOpen(true);
        setIsOpen(false);
      },
    },
  ];

  const itemsDraft = [
    {
      name: 'Опубликовать',
      action: () => {
        isValidToPublish
          ? changeStatus(survey.id, SurveyStatusEnum.PUBLISHED)
          : (() => {
              setDataModalPublish({
                title: ErrorPublishTitle,
                text: ErrorPublishText,
              });
              setErrorModalOpen(true);
            })();
        setIsOpen(false);
      },
    },
    {
      name: 'Предпросмотр',
      action: () => previewLink(),
    },
    {
      name: 'Редактировать',
      action: () => editLink(),
    },
    ...generalItems,
  ];

  const viewLink = () => {
    localStorage.setItem(LocalStorageKeysEnum.PUBLISH_URL, survey?.hash);
    localStorage.setItem(
      LocalStorageKeysEnum.TELEGRAM_BOT_LINK,
      String(survey?.telegram_bot_link),
    );
    setQrCodeModalOpen(true);
    setIsOpen(false);
  };

  const editLink = () => {
    localStorage.setItem(LocalStorageKeysEnum.ID_SERVEY, String(survey?.id));
    setTitleNew(CreateTestEditTitle);
    changeStatusSurveyIdle();
    oneSurveyIdle();
    clearAllListQuestions();
    setIsOpen(false);
    history.push(`/createTest/${survey.id}`);
  };

  const previewLink = () => {
    if (isValidToView) {
      window.open(`/walkthrough/${survey.hash}/draft`);
    } else {
      setDataModalPublish({
        title: ErrorPredPreviewTitle,
        text: ErrorPredPreviewText,
      });
      setErrorModalOpen(true);
      setIsOpen(false);
    }
  };

  const handleUnload = useCallback(() => {
    unloadSurvey(survey.id);
    setIsOpen(false);
  }, [survey, unloadSurvey]);

  const publishedItems = [
    {
      name: 'Посмотреть ссылку',
      action: () => viewLink(),
    },
    {
      name: 'Предпросмотр',
      action: () => previewLink(),
    },
    {
      name: 'Посмотреть аналитику',
      action: () => openAnalytics(),
    },
    {
      name: 'Редактировать',
      action: () => editLink(),
    },
    {
      name: 'Завершить',
      action: () => {
        changeStatus(survey.id, SurveyStatusEnum.ENDED);
        setIsOpen(false);
      },
    },
    {
      name: 'Выгрузить отчет в excel',
      action: () => handleUnload(),
    },
    ...generalItems,
  ];

  const endItems = [
    {
      name: 'Посмотреть ссылку',
      action: () => viewLink(),
    },
    {
      name: 'Предпросмотр',
      action: () => previewLink(),
    },
    {
      name: 'Посмотреть аналитику',
      action: () => openAnalytics(),
    },
    {
      name: 'Редактировать',
      action: () => editLink(),
    },
    {
      name: 'Выгрузить отчет в excel',
      action: () => handleUnload(),
    },
    ...generalItems,
  ];

  const statusIndex = useMemo(
    () =>
      userInit.survey_status.findIndex((item) => item.key === survey.status),
    [userInit, survey],
  );

  const TextWithTooltip = withTooltip()(Text);

  const shareIcon = (
    <svg
      width="24"
      height="24"
      viewBox="0 0 24 24"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      className={cx('SurveyItem__shareIcon')}
      onClick={viewLink}
    >
      <path
        d="M18 16.08C17.24 16.08 16.56 16.38 16.04 16.85L8.91 12.7C8.96 12.47 9 12.24 9 12C9 11.76 8.96 11.53 8.91 11.3L15.96 7.19C16.5 7.69 17.21 8 18 8C19.66 8 21 6.66 21 5C21 3.34 19.66 2 18 2C16.34 2 15 3.34 15 5C15 5.24 15.04 5.47 15.09 5.7L8.04 9.81C7.5 9.31 6.79 9 6 9C4.34 9 3 10.34 3 12C3 13.66 4.34 15 6 15C6.79 15 7.5 14.69 8.04 14.19L15.16 18.35C15.11 18.56 15.08 18.78 15.08 19C15.08 20.61 16.39 21.92 18 21.92C19.61 21.92 20.92 20.61 20.92 19C20.92 17.39 19.61 16.08 18 16.08ZM18 4C18.55 4 19 4.45 19 5C19 5.55 18.55 6 18 6C17.45 6 17 5.55 17 5C17 4.45 17.45 4 18 4ZM6 13C5.45 13 5 12.55 5 12C5 11.45 5.45 11 6 11C6.55 11 7 11.45 7 12C7 12.55 6.55 13 6 13ZM18 20.02C17.45 20.02 17 19.57 17 19.02C17 18.47 17.45 18.02 18 18.02C18.55 18.02 19 18.47 19 19.02C19 19.57 18.55 20.02 18 20.02Z"
        fill="#00395C"
        fillOpacity="0.6"
      />
    </svg>
  );

  const { cron_started_at, cron_finished_at } = survey;

  const getFullTime = (date: Date) => {
    return `${date.toLocaleDateString()} ${date.toLocaleTimeString()}`;
  };

  const start = !cron_started_at
    ? false
    : `${SurveyItemDatePublished} ${getFullTime(new Date(cron_started_at))}`;
  const finish = !cron_finished_at
    ? false
    : `${SurveyItemDateEnded} ${getFullTime(new Date(cron_finished_at))}`;
  const isFullCron = start && finish ? `${start} - ${finish}` : false;

  const displayDate = () => {
    let date = null;
    if (statusIndex === SurveyStatusEnum.DRAFT) {
      if (isFullCron) {
        date = isFullCron;
      } else {
        if (start) date = start;
        if (finish) date = finish;
      }
    }
    if (statusIndex === SurveyStatusEnum.PUBLISHED) {
      if (finish) date = finish;
    }
    return date;
  };

  return (
    <div className={cx('SurveyItem')}>
      <div className={cx('SurveyItem__mainInfo')}>
        <div className={cx('SurveyItem__main')}>
          <div className={cx('SurveyItem__name')}>
            <Text display="inlineBlock" size="xl" weight="bold">
              {survey?.name || 'Без названия'}
            </Text>
          </div>
          {statusIndex === SurveyStatusEnum.PUBLISHED && (
            <TextWithTooltip
              lineHeight="s"
              size="s"
              tooltipProps={{
                content: (
                  <Text size="xs" lineHeight="xs">
                    {SurveyItemShareTooltipText}
                  </Text>
                ),
              }}
            >
              {shareIcon}
            </TextWithTooltip>
          )}
          <div className={cx('SurveyItem__status')}>
            {statusIndex === SurveyStatusEnum.DRAFT && (
              <Badge label="ЧЕРНОВИК" status="system" />
            )}
            {statusIndex === SurveyStatusEnum.PUBLISHED && (
              <Badge label="ОПУБЛИКОВАН" status="normal" />
            )}
            {statusIndex === SurveyStatusEnum.ENDED && (
              <Badge label="ЗАВЕРШЕН" status="success" />
            )}
          </div>
          {survey?.tags?.map((tag) => (
            <div className={cx('SurveyItem__status')} key={tag.id}>
              <Badge size="m" label={tag.name} status="system" view="stroked" />
            </div>
          ))}
        </div>
        <div>
          <Button
            onlyIcon
            iconRight={IconKebab}
            view="clear"
            ref={ref}
            onClick={() => setIsOpen(!isOpen)}
          />
          {isOpen && statusIndex === SurveyStatusEnum.DRAFT && (
            <ContextMenu
              anchorRef={ref}
              items={itemsDraft}
              direction="downStartLeft"
              getLabel={(item) => item.name}
              onClickOutside={() => setIsOpen(false)}
              getOnClick={(item) => item.action}
            />
          )}
          {isOpen && statusIndex === SurveyStatusEnum.PUBLISHED && (
            <ContextMenu
              anchorRef={ref}
              items={publishedItems}
              direction="downStartLeft"
              getLabel={(item) => item.name}
              onClickOutside={() => setIsOpen(false)}
              getOnClick={(item) => item.action}
            />
          )}
          {isOpen && statusIndex === SurveyStatusEnum.ENDED && (
            <ContextMenu
              anchorRef={ref}
              items={endItems}
              direction="downStartLeft"
              getLabel={(item) => item.name}
              onClickOutside={() => setIsOpen(false)}
              getOnClick={(item) => item.action}
            />
          )}
        </div>
      </div>
      <Text size="xs" view="ghost">
        {userInit.survey_type.find((item) => item.key === survey.type)?.name ||
          'Опрос'}{' '}
        {formatDate(new Date(survey.updated_at))}
      </Text>
      <Text size="xs" view="secondary" className={cx('SurveyItem__dateInfo')}>
        {displayDate()}
      </Text>
      <Modal isOpen={deleteModalOpen}>
        <CloseModal
          iconClose={IconClose}
          setModalOpenBlocking={setDeleteModalOpen}
          handleClick={() => deleteSurvey(survey.id)}
          title="Удаление опроса"
          text="Вы уверены, что хотите удалить опрос?"
          textButton="Удалить"
        />
      </Modal>
      <Modal isOpen={errorModalOpen}>
        <ErrorPublishModal
          testData={survey}
          allListQuestion={survey?.cnt_questions || 0}
          setModalErrorPublish={setErrorModalOpen}
          title={dataModalPublish.title}
          text={dataModalPublish.text}
        />
      </Modal>
      <Modal isOpen={qrCodeModalOpen}>
        <QRCodeLinkModal
          closeModal={() => setQrCodeModalOpen(false)}
          surveyName={survey?.name}
        />
      </Modal>
    </div>
  );
};

const mapDispatchToProps = (dispatch: any) => ({
  deleteSurvey: (id: number) => dispatch(loadDeleteSurvey(id)),
  duplicateSurvey: (id: number | string) => dispatch(loadDuplicateSurvey(id)),
  changeStatus: (id: number, status: number) =>
    dispatch(loadChangeSurveyStatus(id, status)),
  changeStatusSurveyIdle: () => dispatch(changeStatusSurveyIdle()),
  oneSurveyIdle: () => dispatch(oneSurveyIdle()),
  setTitleNew: (data: TitleCreateTestType) => dispatch(setTitleNew(data)),
  clearAllListQuestions: () => dispatch(clearAllListQuestions()),
  unloadSurvey: (id: number) => dispatch(unloadSurvey(id)),
});

const mapStateToProps = (state: State, props: ISurveyItemProps) => ({
  duplicateRejected: duplicateSurveyRejectedSelector(state),
  duplicatePending: duplicateSurveyPendingSelector(state),
  deleted: deleteSurveyLoadedSelector(state, props),
  deleteRejected: deleteSurveyRejectedSelector(state),
  deletePending: deleteSurveyPendingSelector(state),
  statusСhanged: changeStatusSurveyLoadedSelector(state, props),
});

export default connect(mapStateToProps, mapDispatchToProps)(SurveyItem);
